module.exports = __webpack_public_path__ + "img/CF.facaa1eb.png";